import React, { useState } from 'react';
import { Link, router } from '@inertiajs/react';
import AuthLayout from '../../components/AuthLayout.jsx';

export default function EmailVerificationPending({ email = '' }) {
  const [submitting, setSubmitting] = useState(false);

  const handleResend = (e) => {
    e.preventDefault();
    setSubmitting(true);
    router.post('/email_verifications/resend', { email }, {
      onFinish: () => setSubmitting(false),
    });
  };

  return (
    <AuthLayout>
      <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <div className="flex justify-center mb-6">
            <img src="/logo.png" alt="123CEU" className="h-12 w-auto" />
          </div>
          <h2 className="mt-2 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Verify your email</h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-900">
              We've sent a verification link to <span className="font-semibold">{email}</span>.
              Click the link in that email to verify your account and get started.
            </p>
          </div>

          <div className="text-center">
            <p className="text-sm text-gray-600 mb-4">Didn't receive the email?</p>
            <button
              onClick={handleResend}
              disabled={submitting}
              className="cursor-pointer inline-block rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 disabled:opacity-50"
            >
              {submitting ? 'Sending...' : 'Resend verification email'}
            </button>
          </div>

          <div className="mt-8 text-center">
            <Link href="/login" className="font-semibold text-indigo-600 hover:text-indigo-500">
              Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
